import { render, staticRenderFns } from "./fee_group_list.vue?vue&type=template&id=0cbf4bdc&scoped=true&"
import script from "./fee_group_list.vue?vue&type=script&lang=js&"
export * from "./fee_group_list.vue?vue&type=script&lang=js&"
import style0 from "./fee_group_list.vue?vue&type=style&index=0&id=0cbf4bdc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf4bdc",
  null
  
)

export default component.exports